var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div ng-class=\"[type ? 'alert-' + type : null]\" role=\"alert\" class=\"alert\"><button type=\"button\" ng-if=\"dismissable\" ng-click=\"$hide()\" class=\"close\"><i class=\"glyphicon glyphicon-close\">&nbsp;</i></button><strong ng-bind=\"title\"></strong><p ng-bind-html=\"content\"></p></div>");;return buf.join("");
}